import { render, staticRenderFns } from "./ItemPhone.vue?vue&type=template&id=c04cdc0e&scoped=true&"
import script from "./ItemPhone.vue?vue&type=script&lang=js&"
export * from "./ItemPhone.vue?vue&type=script&lang=js&"
import style0 from "./ItemPhone.vue?vue&type=style&index=0&id=c04cdc0e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04cdc0e",
  null
  
)

export default component.exports